import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import "../../pages/users/Users.scss";
import { useLazyGetPaymentByIdQuery } from "../../services/main";
import { Loader, showError } from "../../constants";
import { Payments } from "../../types/General";
import useTranslation from "../../hooks/Translation";
import moment from "moment";
import { formatPhoneLtr } from "../../utils/phoneDisplay";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const PaymentDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [paymentDetails] = useLazyGetPaymentByIdQuery();
  const [loading, setLoading] = useState<boolean>();
  const [paymentData, setPaymentData] = useState<Payments>();
  const translate = useTranslation();
  const getPaymentById = async (id: string | undefined) => {
    setLoading(true);
    try {
      const response = await paymentDetails({ paymentId: id }).unwrap();
      if (response?.statusCode === 200) {
        setLoading(false);
        setPaymentData(response?.data);
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getPaymentById(id);
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{translate?.main?.PaymentDetails}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-payments");
            }}
          >
            {translate?.main?.Back}
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item xs={10} className="view_box_list">
                <Grid container spacing={3}>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.main?.Name}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.user?.fullName || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.main?.Email}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.user?.email || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.main?.PhoneNumber}
                      </Typography>
                      <Typography component="p">
                        {formatPhoneLtr(
                          paymentData?.user?.countryCode,
                          paymentData?.user?.phone
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  {paymentData?.subscription ? (
                    <Grid item lg={3} md={3} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">
                          {translate?.main?.SubscriptionPlan}
                        </Typography>
                        <Typography component="p">
                          {paymentData?.subscription?.planName}
                        </Typography>
                      </Box>
                    </Grid>
                  ) : (
                    ""
                  )}

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.main?.PaymentMode}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.paymentMode || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.payment?.paymentStatus}
                      </Typography>
                      <Typography component="p">
                        {Number(paymentData?.paymentStatus) === 1
                          ? translate?.payment?.pending
                          : Number(paymentData?.paymentStatus) === 2
                          ? translate?.payment?.completed
                          : Number(paymentData?.paymentStatus) === 3
                          ? translate?.payment?.cancelled
                          : Number(paymentData?.paymentStatus) === 4
                          ? translate?.payment?.refunded
                          : paymentData?.paymentStatus || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.payment?.transactionId}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.transactionId || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.payment?.providerChargeId}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.providerChargeId || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.payment?.providerStatus}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.providerStatus || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  {paymentData?.failureMessage ? (
                    <Grid item lg={3} md={3} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">
                          {translate?.payment?.failureReason}
                        </Typography>
                        <Typography component="p">
                          {paymentData?.failureMessage}
                        </Typography>
                      </Box>
                    </Grid>
                  ) : null}

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.main?.Amount}
                      </Typography>
                      <Typography component="p">
                        {paymentData?.amount || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translate?.main?.dateOfPurchase}
                      </Typography>
                      <Typography component="p">
                        {moment(paymentData?.createdAt).format(
                          "MMM D, YYYY / hh:mm A"
                        )}
                      </Typography>
                    </Box>
                  </Grid>

                  {paymentData?.paymentType === 1 ? (
                    <Grid item mt={3} xs={12} className="view_box_list">
                      <Typography
                        className="detail_title mn_hdng"
                        component="h2"
                        mb={3}
                      >
                        {translate?.main?.CreditDetails}
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              {translate?.main?.NormalCredits}
                            </Typography>
                            <Typography component="p">
                              {paymentData?.normalCreditsBought || "-"}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              {translate?.main?.HighlightedCredits}
                            </Typography>
                            <Typography component="p">
                              {paymentData?.highlightCreditsBought || "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}></Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}></Grid>
                      </Grid>
                    </Grid>
                  ) : paymentData?.paymentType === 2 ? (
                    <Grid item mt={3} xs={12} className="view_box_list">
                      <Typography
                        className="detail_title mn_hdng"
                        component="h2"
                        mb={3}
                      >
                        {translate?.main?.PlanDetails}
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              {translate?.main?.PlanName}
                            </Typography>
                            <Typography component="p">
                              {paymentData?.subscription?.planName || "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        {/* <Grid item xs={3}>
                        <Box>
                          <Typography component="h5">Plan Type</Typography>
                          <Typography component="p">1 Month</Typography>
                        </Box>
                      </Grid> */}
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              {translate?.main?.PlanPrice}
                            </Typography>
                            <Typography component="p">
                              KD {paymentData?.subscription?.price || "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              {translate?.main?.HighlightedCredits}
                            </Typography>
                            <Typography component="p">
                              {paymentData?.subscription?.highlightCredit ||
                                "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">
                              {translate?.main?.NormalCredits}
                            </Typography>
                            <Typography component="p">
                              {paymentData?.subscription?.normalCredit || "-"}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid item mt={3} xs={12} className="view_box_list">
                      <Typography
                        className="detail_title mn_hdng"
                        component="h2"
                        mb={3}
                      >
                        Agent Assigned
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">Name</Typography>
                            <Typography component="p">
                              {paymentData?.agentAssigned?.fullName || "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        {/* <Grid item xs={3}>
                    <Box>
                      <Typography component="h5">Plan Type</Typography>
                      <Typography component="p">1 Month</Typography>
                    </Box>
                  </Grid> */}
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">Email</Typography>
                            <Typography component="p">
                              {paymentData?.agentAssigned?.email || "-"}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                          <Box>
                            <Typography component="h5">Phone</Typography>
                            <Typography component="p">
                              {formatPhoneLtr(
                                paymentData?.agentAssigned?.countryCode,
                                paymentData?.agentAssigned?.phone
                              )}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={12}></Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* <Card sx={{ mt: 4 }} className="cards">
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Post For Sell" {...a11yProps(0)} />
              <Tab label="Post For Auction" {...a11yProps(1)} />
              <Tab label="Earnings" {...a11yProps(2)} />
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <UserPostForSell></UserPostForSell>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <UserPostForAuction></UserPostForAuction>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <UserEarnings></UserEarnings>
            </CustomTabPanel>
          </Box>
        </Card> */}
      </div>
    </MainContainer>
  );
};

export default PaymentDetails;
